import { SpecialGroup } from './special-group';
import { ExtensionType } from './pingGroup';

export enum ServiceLevel {
  Free = 'Free',
  Basic = 'Basic',
  Standard = 'Standard',
  Premium = 'Premium',
}

export interface BusinessQuota {
  maxExtensions?: number;
}

export interface Business extends SpecialGroup {
  businessType: string;
  extensionType: ExtensionType;
  serviceLevel: ServiceLevel;
  email: string;
  phoneNumber: string;
  phoneNumberCountryCode: string;
  phoneNumberCallingCode: string;
  phoneNumberUserInput: string;
  firstName?: string;
  lastName?: string;
  position?: string;
  website?: string;
  logoUrl?: string;
  organization?: string;
  description?: string;
  isDefault?: boolean;

  extensionCount?: number;
  quotaOverrides?: BusinessQuota;
  socials: {
    google?: string;
    facebook?: string;
    linkedin?: string;
    twitter?: string;
  };
}
